<template>
	<!-- eslint-disable max-len -->
	<svg
		width="31"
		height="24"
		viewBox="0 0 31 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<!-- eslint-disable max-len -->
		<path
			d="M10.5994 18.3L27.5494 1.35C27.9494 0.95 28.4161 0.75 28.9494 0.75C29.4828 0.75 29.9494 0.95 30.3494 1.35C30.7494 1.75 30.9494 2.225 30.9494 2.775C30.9494 3.325 30.7494 3.8 30.3494 4.2L11.9994 22.6C11.5994 23 11.1328 23.2 10.5994 23.2C10.0661 23.2 9.59944 23 9.19944 22.6L0.599438 14C0.199438 13.6 0.00777083 13.125 0.0244375 12.575C0.0411042 12.025 0.249438 11.55 0.649438 11.15C1.04944 10.75 1.52444 10.55 2.07444 10.55C2.62444 10.55 3.09944 10.75 3.49944 11.15L10.5994 18.3Z"
			fill="currentColor"
		/>
		<!-- eslint-enable max-len -->
	</svg>
</template>
